import { EnrollmentChoice_EnrollmentChoiceType as EnrollmentChoiceType } from '__generated__/graphql-types';

import EnrollmentChoices from 'bundles/enroll-common/models/EnrollmentChoices';

export const buildGuestEnrollmentChoices = (s12nIds: string | ReadonlyArray<string>): EnrollmentChoices => {
  const uniqueS12nIds = [...new Set(typeof s12nIds === 'string' ? [s12nIds] : s12nIds)];
  const enrollmentChoices = uniqueS12nIds.map((s12nId) => ({
    enrollmentChoiceType: EnrollmentChoiceType.EnrollThroughS12NSubscriptionTrial,
    enrollmentChoiceInfo: {
      __typename: 'EnrollmentChoice_S12nSubscriptionInfo' as const,
      s12nId,
      availableSubscriptionProducts: [],
    },
  }));

  return new EnrollmentChoices({
    enrollmentChoices,
    specializationId: uniqueS12nIds[0],
  });
};

export default buildGuestEnrollmentChoices;
